// Resolves a raw document type/name to the pair of i18next translation keys
// holding its "Required Documents" tooltip copy (one for "What it is", one
// for "Why we ask for it").
//
// Deliberately reuses what already exists instead of re-declaring it:
// - the tenant checklist lists (`checklist_docs`, loaded from the backend,
//   see src/context/tenantDocumentLists) already map every raw document type
//   to its label translation key (e.g. "Working life certificate" ->
//   "workingLifeCertificate") across every employment-type bucket. We flatten
//   all of those buckets into one reverse lookup and derive the tooltip keys
//   from that same label key (`${labelKey}TooltipWhatItIs` / `...WhyWeAskFor`).
// - the document lists' `docsMap` normalizes raw type aliases from the
//   analysis service (e.g. "Social Security Contribution Report") to the
//   canonical type string the checklist uses.
// Both are passed in by the caller (see DocItem.jsx).

// One reverse lookup per loaded checklist (built on first use)
const labelKeysByChecklist = new WeakMap();

const getLabelKeys = (checklistDocs) => {
  if (!labelKeysByChecklist.has(checklistDocs)) {
    labelKeysByChecklist.set(
      checklistDocs,
      Object.assign(
        {},
        ...Object.entries(checklistDocs)
          .filter(([bucketName]) => bucketName !== "CLAVE_DOCS") // array, not a type->key map
          .map(([, bucket]) => bucket)
      )
    );
  }
  return labelKeysByChecklist.get(checklistDocs);
};

function getDocumentTooltipKeys(rawDocType, docsMap = {}, checklistDocs) {
  if (!rawDocType || !checklistDocs) return null;
  const labelKeys = getLabelKeys(checklistDocs);
  const labelKey = labelKeys[rawDocType] ?? labelKeys[docsMap[rawDocType]];
  if (!labelKey) return null;
  return {
    whatItIsKey: `${labelKey}TooltipWhatItIs`,
    whyWeAskForKey: `${labelKey}TooltipWhyWeAskFor`,
  };
}

module.exports = { getDocumentTooltipKeys };
